import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import GroupMasterHelp from "../../../../Helper/GroupMasterHelp";
import GSTStateMasterHelp from "../../../../Helper/GSTStateMasterHelp";
import MultipleStateSelectionHelp from "../../../../Helper/MultipleStateSelectionHelp";
import CityBroadCastHelp from "../../../../Helper/GetCityByStateHelp";
import {
  Container,
  Paper,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Divider,
  Box,
  TextField
} from "@mui/material";

const companyCode = sessionStorage.getItem("Company_Code");

const AccountMasterPrint = () => {
  const [groupCode, setGroupCode] = useState("");
  const [accoid, setAccoid] = useState("");
  const [groupName, setGroupName] = useState("");
  const [acType, setAcType] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [stateName, setStateName] = useState("");
  const [UniqueCityName, setUniqueCityName] = useState([]);
  const [CityCode, setCityCode] = useState("");
  const [CityName, setCityName] = useState("");
  const [selectedStates, setSelectedStates] = useState([]);
  const [StateNames, setStateNames] = useState([]);
  const [StateDisplayName, setStateDisplayName] = useState("");
  const [StateCodes, setStateCodes] = useState([]);

  const today = new Date().toISOString().slice(0, 10);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const navigate = useNavigate();

  const handleGroupCode = (code, bsId, name) => {
    setGroupCode(code);
    setAccoid(bsId);
    if (name !== undefined) setGroupName(name);
  };


  const handleStateCode = (code, name) => {
    setStateCode(code);
    if (name !== undefined) setStateName(name);
  };

  const handleCity_Code = (cityArray) => {
    if (Array.isArray(cityArray)) {
      const uniqueCitiesMap = new Map();
      cityArray.forEach(city => uniqueCitiesMap.set(city.city_code, city));
      const uniqueCities = Array.from(uniqueCitiesMap.values());

      const cityCodes = uniqueCities.map(c => c.city_code).join(",");
      const cityNames = uniqueCities.map(c => c.city_name_e).join(",");

      setCityCode(cityCodes);
      setCityName(cityNames);
      // setPinCode(uniqueCities[0]?.pincode);

      const uniqueCityNames = uniqueCities.map(c => c.city_name_e);
      setUniqueCityName(uniqueCityNames); // ✅ Save for param use
    }
  };

  

  const handleGetReportClick = (type) => {
    let state = {};

    switch (type) {
      case "acType":
        if (!acType) return alert("Please select an Account Type");
        state = { acType, companyCode, label: "Account Type wise list" };
        break;

      case "groupCode":
        if (!groupCode) return alert("Please select a Group Code");
        state = { groupCode, companyCode, label: "Group Code wise list" };
        break;

      case "stateWise":
        state = { stateWise: true, label: "State wise list" };
        break;

      default:
        return alert("Invalid report type");
    }

    navigate(`/accountmaster-print-report`, { state });
  };

  return (
    <Container maxWidth="md" style={{ paddingTop: 18, paddingBottom: 18 }}>
      <Paper
        elevation={0}
        style={{
          borderRadius: 14,
          border: "1px solid rgba(0,0,0,0.10)",
          background: "#fff",
          padding: 18,
        }}
      >
        {/* Header */}
        <Box style={{ padding: "4px 4px 10px 4px" }}>
          <Typography
            variant="h5"
            style={{ fontWeight: 700, letterSpacing: 0.2 }}
          >
            Account List
          </Typography>
          <Typography
            variant="body2"
            style={{ color: "rgba(0,0,0,0.65)", marginTop: 4 }}
          >
            Generate account lists by Account Type, Group Code, or State.
          </Typography>
        </Box>

        <Divider style={{ margin: "12px 0 16px 0" }} />

        <Grid container spacing={2}>

          <Grid item xs={12} sm={3}>
                          <TextField
                            label="From Date"
                            type="date"
                             name = "fromDate"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                          />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <TextField
                            label="To Date"
                            type="date"
                            name = "toDate"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            fullWidth
                            InputLabelProps={{
                              shrink: true,
                            }}
                            size="small"
                          />
                        </Grid>
          {/* Account Type Wise */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                borderRadius: 12,
                padding: 14,
                border: "1px solid rgba(0,0,0,0.10)",
                background: "rgba(0,0,0,0.015)",
              }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: 650, marginBottom: 10 }}>
                Account Type Wise
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={7}>
                  <FormControl size="small" fullWidth>
                    <InputLabel>Account Type</InputLabel>
                    <Select
                      label="Account Type"
                      value={acType}
                      onChange={(e) => setAcType(e.target.value)}
                    >
                      <MenuItem value="P">Party</MenuItem>
                      <MenuItem value="OP">Other Than Party</MenuItem>
                      <MenuItem value="S">Supplier</MenuItem>
                      <MenuItem value="B">Bank</MenuItem>
                      <MenuItem value="C">Cash</MenuItem>
                      <MenuItem value="R">Relative</MenuItem>
                      <MenuItem value="F">Fixed Assets</MenuItem>
                      <MenuItem value="I">Interest Party</MenuItem>
                      <MenuItem value="EX">Income</MenuItem>
                      <MenuItem value="E">Expenses</MenuItem>
                      <MenuItem value="O">Trading</MenuItem>
                      <MenuItem value="M">Mill</MenuItem>
                      <MenuItem value="T">Transport</MenuItem>
                      <MenuItem value="BR">Broker</MenuItem>
                      <MenuItem value="RP">Retail Party</MenuItem>
                      <MenuItem value="CR">Cash Retail Party</MenuItem>
                      <MenuItem value="CP">Capital</MenuItem>
                      <MenuItem value="SP">Farmer</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => handleGetReportClick("acType")}
                    style={{
                      textTransform: "none",
                      fontWeight: 650,
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    Get Report
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* Group Code Wise */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                borderRadius: 12,
                padding: 14,
                border: "1px solid rgba(0,0,0,0.10)",
                background: "rgba(0,0,0,0.015)",
              }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: 650, marginBottom: 10 }}>
                Group Code Wise
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={7}>
                  <Box style={{ width: "100%" }}>
                    <GroupMasterHelp
                      onAcCodeClick={handleGroupCode}
                      name="Group_Code"
                      GroupName={groupName}
                      GroupCode={groupCode}
                    />
                  </Box>

                  {(groupCode || groupName) && (
                    <Typography
                      variant="caption"
                      style={{
                        display: "inline-block",
                        marginTop: 6,
                        color: "rgba(0,0,0,0.65)",
                      }}
                    >
                      Selected: {groupCode ? `Code ${groupCode}` : ""}{" "}
                      {groupName ? `• ${groupName}` : ""}
                    </Typography>
                  )}
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Button
                    fullWidth
                    variant="contained"
                    onClick={() => handleGetReportClick("groupCode")}
                    style={{
                      textTransform: "none",
                      fontWeight: 650,
                      borderRadius: 10,
                      padding: "10px 12px",
                    }}
                  >
                    Get Report
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* State Wise */}
          <Grid item xs={12}>
            <Paper
              elevation={0}
              style={{
                borderRadius: 12,
                padding: 14,
                border: "1px solid rgba(0,0,0,0.10)",
                background: "rgba(0,0,0,0.015)",
              }}
            >
              <Typography variant="subtitle1" style={{ fontWeight: 650, marginBottom: 10 }}>
                State Wise
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={7}>
                  <Grid item xs={12} sm={7}>
                    <Box style={{ width: "100%" }}>
                      {/* <GSTStateMasterHelp
                      onAcCodeClick={handleStateCode}
                      name="GstStateCode"
                      GstStateName={stateName}
                      GstStateCode={stateCode}
                    /> */}

                      <MultipleStateSelectionHelp
                        name="GstStateCode"
                        GstStateName={stateName}
                        GstStateCode={stateCode}
                        onAcCodeClick={(selectedArray) => {
                          if (Array.isArray(selectedArray)) {
                            setSelectedStates(selectedArray);

                            const stateCodes = selectedArray.map(s => s.State_Code);
                            const stateNames = selectedArray.map(s => s.State_Name);

                            setStateCodes(stateCodes);
                            setStateNames(stateNames);


                            const labelLimit = 5;
                            const label = stateNames.length > labelLimit
                              ? `${stateNames.slice(0, labelLimit).join(", ")}, ...`
                              : stateNames.join(", ");
                            setStateDisplayName(label);

                            setStateCode(stateCodes.join(","));
                            setStateName(label);
                          } else {
                            setSelectedStates([]);
                            setStateCodes([]);
                            setStateNames([]);
                            setStateDisplayName("");
                            setStateCode("");
                            setStateName("");
                          }
                        }}
                      />

                      <CityBroadCastHelp
                        name="City_Code"
                        onAcCodeClick={handleCity_Code}
                        State_Code={selectedStates}
                        CityName={CityName}
                        CityCode={CityCode}
                        tabIndexHelp={8}
                      // disabledFeild={!isEditing && addOneButtonEnabled}
                      />
                    </Box>

                    {(stateCode || stateName) && (
                      <Typography
                        variant="caption"
                        style={{
                          display: "inline-block",
                          marginTop: 6,
                          color: "rgba(0,0,0,0.65)",
                        }}
                      >
                        Selected: {stateCode ? `Code ${stateCode}` : ""}{" "}
                        {stateName ? `• ${stateName}` : ""}
                      </Typography>
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={12} sm={5}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => handleGetReportClick("stateWise")}
                    style={{
                      textTransform: "none",
                      fontWeight: 650,
                      borderRadius: 10,
                      padding: "10px 12px",
                      borderWidth: 2,
                    }}
                  >
                    Get Report
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default AccountMasterPrint;



// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import GroupMasterHelp from "../../../../Helper/GroupMasterHelp";
// import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
// import "../Ledger.css";

// const companyCode = sessionStorage.getItem('Company_Code')
// var label;
// const AccountMasterPrint = () => {
//   const [groupCode, setGroupCode] = useState("");
//   const [accoid, setAccoid] = useState("");
//   const [groupName, setGroupName] = useState("");
//   const [acType, setAcType] = useState("");

//   const navigate = useNavigate();


//   const handleGroupCode = (code, bsId) => {
//     setGroupCode(code);
//     setAccoid(bsId);
//   };

//   const handleGetReportClick = (type) => {
//     let state = {};

//     switch (type) {
//       case "acType":
//         if (!acType) {
//           alert("Please select an Account Type");
//           return;
//         }
//         state = { acType, companyCode, label: "Account Type wise list" }; // Include companyCode for AcType-based reports
//         break;

//       case "groupCode":
//         if (!groupCode) {
//           alert("Please select a Group Code");
//           return;
//         }
//         state = { groupCode, companyCode, label: "Group Code wise list" }; // Include companyCode for groupCode-based reports
//         break;

//       case "stateWise":
//         state = { stateWise: true, label: "State wise list" }; // Include only stateWise=true, no companyCode
//         break;

//       default:
//         alert("Invalid report type");
//         return;
//     }

//     navigate(`/accountmaster-print-report`, { state });
//   };


//   return (
//     <div className="ledger-form-container">
//       <h2>Account List</h2>
//       <form>
//         {/* Account Type Selector */}
//         <div className="form-row">
//           <label htmlFor="Ac_Type">Account Type:</label>
//           <FormControl size="small" fullWidth sx={{ width: "20vh" }}>
//             <InputLabel>Type</InputLabel>
//             <Select
//               id="Ac_Type"
//               name="Ac_Type"
//               value={acType}
//               onChange={(e) => setAcType(e.target.value)}
//             >
//               <MenuItem value="P">Party</MenuItem>
//               <MenuItem value="OP">Other Than Party</MenuItem>
//               <MenuItem value="S">Supplier</MenuItem>
//               <MenuItem value="B">Bank</MenuItem>
//               <MenuItem value="C">Cash</MenuItem>
//               <MenuItem value="R">Relative</MenuItem>
//               <MenuItem value="F">Fixed Assets</MenuItem>
//               <MenuItem value="I">Interest Party</MenuItem>
//               <MenuItem value="EX">Income</MenuItem>
//               <MenuItem value="E">Expenses</MenuItem>
//               <MenuItem value="O">Trading</MenuItem>
//               <MenuItem value="M">Mill</MenuItem>
//               <MenuItem value="T">Transport</MenuItem>
//               <MenuItem value="BR">Broker</MenuItem>
//               <MenuItem value="RP">Retail Party</MenuItem>
//               <MenuItem value="CR">Cash Retail Party</MenuItem>
//               <MenuItem value="CP">Capital</MenuItem>
//               <MenuItem value="SP">Farmer</MenuItem>
//             </Select>
//           </FormControl>
//           <button
//             type="button"
//             onClick={() => handleGetReportClick("acType")}
//           >
//             Account Type Wise List
//           </button>
//         </div>

//         {/* Group Code Selector */}
//         <div className="form-row">
//           <label htmlFor="Group_Code">Group Code:</label>
//           <GroupMasterHelp
//             onAcCodeClick={handleGroupCode}
//             name="Group_Code"
//             GroupName={groupName}
//             GroupCode={groupCode}
//           />
//           <button
//             type="button"
//             onClick={() => handleGetReportClick("groupCode")}
//           >
//             Group Code Wise Account List
//           </button>
//         </div>

//         {/* State-Wise Button */}
//         <div className="form-row">
//           <button
//             type="button"
//             onClick={() => handleGetReportClick("stateWise")}
//           >
//             State Wise Account List
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AccountMasterPrint;
